import { useTranslator } from '@Localization';
import { Button } from '@mui/joy';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { S_Modal } from '../../../../design/modals/modal/S_Modal';
import { InputStatus } from '../../../models/error.model';
import { PasswordWithScoreInputsContainer } from '../../auth/containers/PasswordWithScoreInputsContainer';

interface IAddCreditsModalProps {
  show: boolean;
  passwordStatus: InputStatus;
  passwordScore: number;
  onPasswordStatusChange: (passwordStatus: InputStatus) => void;
  onClose: () => void;
  onChange: (value: string, score: number) => void;
  onSave: () => Promise<void>;
}

export const ChangePasswordModal = observer((props: IAddCreditsModalProps): ReactElement => {
  const { t } = useTranslator();

  const handleToggle = (): void => {
    props.onClose();
  };

  return (
    <S_Modal
      isOpen={props.show}
      toggle={handleToggle}
      headerText={t('change_password')}
      buttons={
        <>
          <Button
            color='neutral'
            variant='outlined'
            onClick={handleToggle}
          >
            {t('cancel')}
          </Button>
          <Button
            onClick={() => {
              void props.onSave();
            }}
            disabled={props.passwordStatus.isValid === false || props.passwordScore < 2}
          >
            {t('save')}
          </Button>
        </>
      }
    >
      <PasswordWithScoreInputsContainer
        autoComplete='one-time-code'
        labelText={t('new_password')}
        onPasswordChange={props.onChange}
        onPasswordStatusChange={props.onPasswordStatusChange}
      />
    </S_Modal>
  );
});
